export default __webpack_public_path__ + "static/media/car-header.a5771746.svg";